import React, {Component, Fragment} from 'react';
import Slider from "react-slick";
import style from '../css/matchdayMoreBets.css';
import {getText} from '../../../../../helpers/localization';
import {calculateTimeDifference, formatTimeInSecondsToMMSS} from '../../../../../helpers/helperFunctions';
import {ASSETS_URL} from '../../../../../constants/endpoints';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import {setSelectedMatchdayEventId} from "../../../../../actions/eventsActions";

class MoreBetsHeader extends Component {

    constructor(props) {
        super(props);
        let store = this.props.store;
        let storeData = store.getState();
        let selectedMatchdayEventId = this.props.selectedMatchdayEventId;
        this.selectedMatchdayEvent = (storeData.vpp.events[storeData.vpp.selectedEventIndex]).find(function (item) {
            return item.eventId == selectedMatchdayEventId;
        });
        this.selectedMatchdayEvents = storeData.vpp.events[storeData.vpp.selectedEventIndex];
        this.currentIndex = this.selectedMatchdayEvent.order - 1;
        this.state = {timeLeft: this._getTimeLeft()};
        this.sliderConfig = {
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            afterChange: (currentSlide) => {
                this._switchEvent(currentSlide);
                this.currentIndex = currentSlide;
            },
        };
    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();
        if (nextProps && storeData) {
            this.setState({
                selectedEventIndex: storeData.vpp.selectedEventIndex,
                events: storeData.vpp.events,
                selectedMatchdayEvent: nextProps.selectedMatchdayEvent,
                timeLeft: this._getTimeLeft()
            });
        }
    }

    _switchEvent(index) {
        let selectedEvent = this.selectedMatchdayEvents[index];
        this.props.store.dispatch(setSelectedMatchdayEventId(selectedEvent.eventId, this.props.store));
        this.selectedMatchdayEvent = selectedEvent;
        this.slider.slickGoTo(index);
    }

    _previousEvent() {
        let currentIndex = this.currentIndex > 0 ? this.currentIndex - 1 : 7;
        let selectedEvent = this.selectedMatchdayEvents[currentIndex];
        this.props.store.dispatch(setSelectedMatchdayEventId(selectedEvent.eventId, this.props.store));
        this.selectedMatchdayEvent = selectedEvent;
        this.slider.slickGoTo(currentIndex);
    }

    _nextEvent() {
        let currentIndex = this.currentIndex < 7 ? this.currentIndex + 1 : 0;
        let selectedEvent = this.selectedMatchdayEvents[currentIndex];
        this.props.store.dispatch(setSelectedMatchdayEventId(selectedEvent.eventId, this.props.store));
        this.selectedMatchdayEvent = selectedEvent;
        this.slider.slickGoTo(currentIndex);
    }

    _closeMoreBetsScreen() {
        this.props.store.dispatch(setSelectedMatchdayEventId(undefined, this.props.store));
        document.getElementById("bottomContainer").scrollTo({top: 0, behavior: 'instant'}) //for desktop view
        document.getElementById('gameIframe').scrollTo({top: 0, behavior: 'instant'})  //for mobile view
    }

    findKit(awayKitId, length) {
        let id = '' + awayKitId;
        while (id.length < length) {
            id = '0' + id;
        }
        return id;
    }

    componentDidMount() {
        this.interval = setInterval(this._updateTimeLeft.bind(this), 300);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    _updateTimeLeft() {
        this.setState({
            ...this.state,
            timeLeft: this._getTimeLeft()
        });
    }

    _getTimeLeft() {
        let store = this.props.store;
        let storeData = store.getState();
        return (calculateTimeDifference(Date.now() - storeData.vpp.serverTimeOffset,
            this.selectedMatchdayEvent.eventTimeDate) / 1000);
    }

    render() {
        let store = this.props.store;
        let storeData = store.getState();
        let eventHeaders = [];
        let scrollHandler = []
        let homeTeamSilk = ASSETS_URL + "soccer3/silks/Small/Shirts/Team_";
        let awayTeamSilk = ASSETS_URL + "soccer3/silks/Small/Shirts/Team_";
        this.selectedMatchdayEvents.map((matchdayEvent, index) => {
            eventHeaders.push(<Fragment key={index}>
                <div className={style.eventInfo}>
                    {getText('Matchday_' + matchdayEvent.teamOne, this.props.store).toUpperCase()}{' '}
                    <div className={style.silkContainer}>
                        <img className={style.image}
                             src={homeTeamSilk + this.findKit(matchdayEvent.homeKitId, 4) + ".png"}/>
                    </div>
                    {' ' + getText('VS', this.props.store) + ' '}
                    <div className={style.silkContainer}>
                        <img className={style.image}
                             src={awayTeamSilk + this.findKit(matchdayEvent.awayKitId, 4) + ".png"}/>
                    </div>
                    {' '}
                    {getText('Matchday_' + matchdayEvent.teamTwo, this.props.store).toUpperCase()}
                </div>
            </Fragment>);
            if (matchdayEvent.eventId == this.selectedMatchdayEvent.eventId) {
                scrollHandler.push(<div className={`${style.circle} ${style.selectedCircle}`} key={index}
                                        onClick={() => this._switchEvent(index)}></div>);
            } else {
                scrollHandler.push(<div className={style.circle} key={index}
                                        onClick={() => this._switchEvent(index)}></div>);
            }
        });

        return (
            <div className={style.headerContainer}>
                <div className={style.backButtonHolder}>
                    <div className={style.backButton} onClick={() => this._closeMoreBetsScreen()}>
              <span className={style.backButtonWrapper}>
                  <div className={style.curvedarrow}></div>
              </span>
                    </div>
                </div>
                <div className={style.matchdayEventInfoHolder}>
                    <div
                        className={style.matchdayInfo}>{getText('Matchday', store) + ' ' + this.selectedMatchdayEvent.leagueDay + '/30'}</div>
                    <div className={style.matchdayInfo}>{formatTimeInSecondsToMMSS(this.state.timeLeft)}</div>
                </div>
                <div className={style.eventSwitchHolder}
                     onLoad={() => this._switchEvent(this.selectedMatchdayEvent.order - 1)}>
                    <Slider ref={slider => (this.slider = slider)} {...this.sliderConfig}>
                        {eventHeaders}
                    </Slider>
                    <div className={style.eventscrollHolder}>
                        <div className={style.previousEventSwitch} onClick={() => this._previousEvent()}></div>
                        {scrollHandler}
                        <div className={style.match}>{getText('MATCH', this.props.store)}</div>
                        <div className={style.matchPosition}>{(this.selectedMatchdayEvent.order) + '/8'}</div>
                        <div className={style.nextEventSwitch} onClick={() => this._nextEvent()}></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default MoreBetsHeader;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/components/moreBetsHeader.js